export function getCompleteAddress(houseNumber?: string, address?: string, buildingFloorStaircase?: string, localityPoBox?: string): string {
  return `${houseNumber || ''} ${address || ''}`?.trim();
}

/**
 * Scroll à l'élément
 * @param id id de l'élément
 */
export function scrollTo(id: string): void {
  const yOffset = -65;
  const element = document.getElementById(id);

  if (element) {
    const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}

/**
 * Formate une date au format français jj/mm/aaaa (en UTC, comme le pipe `date` des templates)
 * @param date date à formater
 * @returns la date formatée, ou une chaîne vide si la date est absente ou invalide
 */
export function formatDateFr(date?: Date | string | null): string {
  if (!date) return '';

  const parsed = date instanceof Date ? date : new Date(date);
  if (isNaN(parsed.getTime())) return '';

  const day = `${parsed.getUTCDate()}`.padStart(2, '0');
  const month = `${parsed.getUTCMonth() + 1}`.padStart(2, '0');

  return `${day}/${month}/${parsed.getUTCFullYear()}`;
}
